export class Audioplayer {
    player: Element;

    constructor(player) {
        this.player = player;
        this.init();
    }

    init() {
        this.addEventListeners()
    }

    addEventListeners() {
        const audio: HTMLMediaElement = this.player.querySelector('[data-audioplayer-audio]'),
            duration: HTMLElement = this.player.querySelector('[data-audioplayer-time="duration"]'),
            playButton: HTMLElement = this.player.querySelector('[data-audioplayer-play-button]'),
            progress: HTMLElement = this.player.querySelector('[data-audioplayer-progress="progress"]'),
            current: HTMLElement = this.player.querySelector('[data-audioplayer-time="current"]'),
            progressBar: HTMLElement = this.player.querySelector('[data-audioplayer-progress="bar"]'),
            shareButton: HTMLElement = this.player.querySelector('[data-audioplayer-share="button"]'),
            shareOverlay: HTMLElement = this.player.querySelector('[data-audioplayer-share="overlay"]');

        audio.load();

        audio.addEventListener('loadeddata', () => {
            duration.innerHTML = this.secondsInMinutesAndSeconds(Math.round(audio.duration));
        });

        audio.addEventListener('play', () => {
            this.player.classList.add('c-audioplayer--playing');
        });

        audio.addEventListener('pause', () => {
            this.player.classList.remove('c-audioplayer--playing');
        });

        audio.addEventListener('timeupdate', () => {
            current.innerHTML = this.secondsInMinutesAndSeconds(Math.round(audio.currentTime));
            progress.style.width = 100 * (audio.currentTime / audio.duration) + '%';
        });

        playButton.addEventListener('click', () => {
            if (audio.paused) {
                document.querySelectorAll<HTMLMediaElement>('[data-audioplayer-audio]').forEach((item) => {
                    item.pause();
                });
                if (audio.ended) {
                    audio.currentTime = 0;
                }
                audio.play();
            }
            else {
                audio.pause();
            }
        });

        progressBar.addEventListener('click', (event) => {
            let clickPercentage = ((event.clientX - progressBar.getBoundingClientRect().left) / progressBar.clientWidth) * 100;
            audio.currentTime = (audio.duration / 100) * clickPercentage;
        });

        shareButton.addEventListener('click', () => {
            shareOverlay.classList.toggle('is-visible');
        });
    }

    secondsInMinutesAndSeconds(time) {
        let pad = function(num, size) {
            return ('000' + num).slice(size * -1);
        };
        let minutes = pad(Math.floor(time / 60), 2);
        let seconds = pad(time - (Math.floor(time / 60) * 60), 2);
        return minutes + ':' + seconds;
    }

}
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('[data-audioplayer]').forEach(player => {
        new Audioplayer(player);
    });
});
